:host{display:block}:host .logo{align-items:flex-end;display:flex;height:100%;padding:5px 10px;background-color:#fff}:host .logo .logo-img{height:auto;width:auto;background-color:#fff}
/*# sourceMappingURL=logo.component-YVLXSQA4.css.map */
